// extracted by mini-css-extract-plugin
module.exports = {"root":"CookieConsent_root__2OH2W","message":"CookieConsent_message__3ZKd6","cookieLink":"CookieConsent_cookieLink__39im0","continueBtn":"CookieConsent_continueBtn__1dvY8"};